import { render, staticRenderFns } from "./kankolek_index.vue?vue&type=template&id=35839939&scoped=true"
import script from "./kankolek_index.vue?vue&type=script&lang=js"
export * from "./kankolek_index.vue?vue&type=script&lang=js"
import style0 from "./kankolek_index.vue?vue&type=style&index=0&id=35839939&prod&scoped=true&lang=css"
import style1 from "./kankolek_index.vue?vue&type=style&index=1&id=35839939&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35839939",
  null
  
)

export default component.exports